import React, { useEffect, useState } from "react";
import {Card, CardBody, Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import logoLight from "../../Assets/images/Omphalos-small.png";
import { toast } from "react-toastify";
import {
  CLICK_HERE,
  CONFIRM_PASSWORD_LABEL,
  EMPTY_STRING,
  NEW_PASSWORD_LABEL,
  OTP_LABEL,
  PASSWORDS_MUST_MATCH,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_TITLE,
  WAIT_I_REMEMBER,
} from "Components/constants/commonNames";
import { REQUEST_UPDATE_PASSWORD_COMMON} from "API/Services/common";
import BaseButton from "../../Components/Common/BaseButton";
import BaseInput from "../../Components/Common/BaseInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import { checkStatusCodeSuccess, SESSION_GET_ITEM } from "Components/constants/enums";

const validationSchema = Yup.object().shape({
  otp: Yup.string().required(validationMessages.required(OTP_LABEL))
          .min(6, validationMessages.minLength(OTP_LABEL,6))
,

  newPassword: Yup.string()
    .min(8, validationMessages.minLength(NEW_PASSWORD_LABEL,8))
    .required(validationMessages.required(NEW_PASSWORD_LABEL)
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), ""], PASSWORDS_MUST_MATCH)
    .required(validationMessages.required(CONFIRM_PASSWORD_LABEL)),
});

const PasswordUpdatePage = (props: any) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);

  const initialValues = {
    otp: "",
    newPassword: "",
    confirmPassword: "",
  };

  const handleSubmit = async (values: typeof initialValues) => {
    setLoader(true);
    const payload = { ...values };

    try {
      const resp: any = await REQUEST_UPDATE_PASSWORD_COMMON(payload);
      if (checkStatusCodeSuccess(resp?.statusCode)) {
        toast.success(resp.message);
        navigate("/login");
      } else {
        toast.error(resp.message);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message ||error.message);
    } finally {
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const emailId = SESSION_GET_ITEM("email")
    if(!emailId){
      navigate("/forgot-password")
    }
  }, []);
  document.title = UPDATE_PASSWORD_TITLE;


  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container className="mt-5">
            <Row>
              <Col lg={12}>
                <div className="text-center mb-4 text-white-50">
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" className="logocss" />
                  </Link>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-2 login-card">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <span className="text-info hello">{UPDATE_PASSWORD}</span>
                    </div>
                   
                    <div className="p-2 mt-1">
                      <form onSubmit={formik.handleSubmit}>
                        <BaseInput
                          label={OTP_LABEL}
                          name="otp"
                          className="mb-3"
                          type="number"
                          maxLength={6}
                          placeholder={InputPlaceHolder(OTP_LABEL)}
                          value={formik.values.otp}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.otp}
                          touched={formik.touched.otp}
                        />
                        <BaseInput
                          label={NEW_PASSWORD_LABEL}
                          name="newPassword"
                          className="mb-3"
                          type="password"
                          placeholder={InputPlaceHolder(NEW_PASSWORD_LABEL)}
                          value={formik.values.newPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.newPassword}
                          touched={formik.touched.newPassword}
                          showPasswordToggle={true}
                        />
                        <BaseInput
                          label={CONFIRM_PASSWORD_LABEL}
                          name="confirmPassword"
                          type="password"
                          className="mb-3"
                          placeholder={InputPlaceHolder(CONFIRM_PASSWORD_LABEL)}
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.confirmPassword}
                          touched={formik.touched.confirmPassword}
                          showPasswordToggle={true}
                        />
                        <div>
                          <BaseButton
                            text={loader ? EMPTY_STRING : UPDATE_PASSWORD}
                            loading={loader}
                            type="submit"
                            color="info"
                          />
                        </div>
                      </form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <div className="text-center">
                {WAIT_I_REMEMBER}
                          <Link to="/login" className="text-info">
                            {CLICK_HERE}
                          </Link>
                        </div>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(PasswordUpdatePage);

